<template>
  <div class="main">
    <div class="bg"></div>
    <div class="info">
      <div class="title">WANOS 空间音频 SDK 演示</div>
      <p class="text">
        我们构建了这个小小的虚拟世界来展示各种可以通过WANOS 空间音频 SDK
        实现的沉浸式音频用例。这里有一个指南，可以带您快速体验！
      </p>
      <div class="bg-img">
        <img src="/space/images/big-bg-new-pic.png" alt="" />
      </div>
      <p class="text">
        我们很想认识您！如果您不想分享任何个人信息，可不填入信息，并以访客的身份进入！
      </p>
      <div class="form">
        <div class="list">
          <div class="list-title">您的姓名：</div>
          <div class="list-input">
            <el-input v-model="name" placeholder="您的姓名"></el-input>
          </div>
        </div>
        <div class="list">
          <div class="list-title">您的联系方式：</div>
          <div class="list-input">
            <el-input v-model="phone" placeholder="目前仅支持大陆地区手机号">
              <template>+86</template>
            </el-input>
          </div>
        </div>
        <div class="list">
          <div class="list-title">公司名称：</div>
          <div class="list-input">
            <el-input v-model="componeny" placeholder="公司名称"></el-input>
          </div>
        </div>
      </div>
      <p class="text">
        我们致力于保护和尊重您的隐私的更多信息，请查看我们的<a
          @click="linkAgreement"
          href="javascript:;"
          >隐私协议</a
        >。
      </p>
      <p class="text">点击下方进入演示，即同意WANOS存储和处理上述隐私信息</p>
      <div class="action">
        <el-button type="primary" @click="linkHome">立即演示</el-button>
      </div>
    </div>
    <!-- <Home v-show="false"></Home> -->
  </div>
</template>

<script>
import Home from "./Home.vue";
import { holdcall } from "../assets/js/axios";

export default {
  components: { Home },
  data() {
    return {
      name: "",
      phone: "",
      componeny: "",
    };
  },
  methods: {
    linkHome() {
      if (this.name != "" || this.phone != "" || this.componeny != "") {
        holdcall(this.name, this.phone, this.componeny, function (info) {
          if (info.code == "30000") {
            // console.log(info);
          }
        });
      }
      this.$router.push({ path: "/space/wanos_park" });
    },
    linkAgreement() {
      let url = "https://wanos.cc/home/Agreement?type=2";
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  padding-bottom: 100px;
  .bg {
    position: absolute;
    top: -115px;
    width: 100%;
    height: 388px;
    z-index: 0;
    background: linear-gradient(
      180deg,
      rgba(97, 201, 241, 0.4) 0%,
      rgba(97, 201, 241, 0) 100%
    );
  }
}
.info {
  position: absolute;
  z-index: 1;
  top: -0;
  margin-left: -600px;
  left: 50%;
  max-width: 1200px;
  height: 100%;
  padding: 20px 40px;
  .title {
    font-size: 24px;
    color: #2d2d2d;
    font-family: "PingFang SC";
    line-height: 45px;
    text-align: left;
  }
  .text {
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 30px;
    /* identical to box height, or 129% */
    color: #2d2d2d;
    text-align: left;
  }
  .bg-img {
    width: calc(100% - 80px);
    border: 6px solid #ffffff;
    display: flex;
    filter: drop-shadow(0px 10px 20px rgba(0, 0, 0, 0.1));
    img {
      width: 100%;
    }
  }
  .form {
    width: 100%;
    display: flex;
    padding-top: 20px;
    margin-top: 20px;
    margin-bottom: 40px;
    .list {
      margin-right: 20px;
      .list-title {
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 35px;
        color: #3d72fc;
        text-align: left;
        padding-left: 5px;
        text-align: left;
      }
      .list-input {
        position: relative;
        .el-input {
          width: 379.33px;
          .el-input__inner {
            background: #f8f8f8 !important;
            border: 1px solid #d9d9d9;
            border-radius: 3px;
          }
        }
      }
    }
  }
}
:deep(.el-input__inner) {
  background: #f8f8f8;
  border: 0px solid #d9d9d9;
  border-radius: 3px;
}
:deep(.el-input__wrapper) {
  background: #f8f8f8;
}
.action {
  text-align: left;
}
</style>
